import { Box, Typography } from '@mui/material'
import React from 'react'
import { ReqField } from '../CustomComponents/CustomLoader'
import CustomTextField from '../forms/theme-elements/CustomTextField'

const TextInputs = ({ title, name, value, handleChange, type, required }) => {
    return (
        <Box>
            <Typography
                variant="subtitle1"
                fontWeight={600}
                component="label"
                htmlFor={name}
                mb="5px"
            >
                {title} {required !== false ? <ReqField /> : <br />}
            </Typography>
            {
                type === 'file' ?
                    <CustomTextField
                        id={name}
                        variant="outlined"
                        type={type}
                        fullWidth
                        onChange={handleChange}
                        name={name}
                    />
                    :
                    <CustomTextField
                        id={name}
                        variant="outlined"
                        type={type}
                        fullWidth
                        value={value}
                        onChange={handleChange}
                        name={name}
                    />
            }
        </Box>
    )
}

export default TextInputs
